import React from 'react';
import PropTypes from 'prop-types';
import { Table, Progress,Tooltip } from 'antd';
import moment from 'moment';
import coin1 from 'assets/img/coin1.png';
import coin2 from 'assets/img/coin2.png';
import coin3 from 'assets/img/coin3.png';
// import certificate from 'assets/img/certificate.png';

ProgressTable.propTypes = {
    items: PropTypes.array,
    isLoading: PropTypes.bool,
    type: PropTypes.string, // subject, chapter, topic
    showColumns: PropTypes.array,
}

ProgressTable.defaultProps = {
    items: [],
    isLoading: false,
    type: 'subject',
    showColumns: [],
};

export default function ProgressTable({ items, isLoading, type, showColumns,pagination }) {
    const subjectColumns = [
        { title: 'S.No', dataIndex: 'index', key: 'index' },
        { title: 'Subject Name', dataIndex: 'subjectName', key: 'id', render: text => <span className="cursor-pointer">{text}</span> },
        { title: 'No. Of Island', dataIndex: 'numIsland', key: 'id', align: 'center' },
        { title: 'Chapter Completion', dataIndex: 'chapterComplete', key: 'id', align: 'center', render: value => chapterProgress(value) },
        { title: 'Time', dataIndex: 'time', key: 'id', align: 'center' },
        { title: 'Currency', key: 'currency', align: 'center', render: (data) => currencyList(data) },
    ];

    const chapterColumns = [
        { title: 'S.No', dataIndex: 'index', key: 'index' },
        { title: 'Chapter Name', dataIndex: 'chapterName', key: 'id', render: text => <span className="cursor-pointer">{text}</span> },
        { 
        //  title: 'Island',
         title:<Tooltip>Topics in this chapter&nbsp; <Tooltip title="It indicates the number of topics in the chapter."> <icon className="icon-inform text-icon dash-icon-inform" aria-hidden="true"></icon> </Tooltip></Tooltip>,
         dataIndex: 'numIsland', 
         key: 'id', align: 'center' },
        { 
        // title: 'Completion', 
        title:<Tooltip>Completion&nbsp; <Tooltip title="It denotes the percentage of completion of the chapter."> <icon className="icon-inform text-icon dash-icon-inform" aria-hidden="true"></icon> </Tooltip></Tooltip>,
        dataIndex: 'chapterComplete',
         key: 'id', align: 'center', render: value => chapterProgress(value) },
        // { title: 'Accuracy %', dataIndex: 'accuracy', key: 'id', align: 'center' },
        { 
            // title: 'Currency',
        //   title: 'Score',
        title:<Tooltip>Total Score&nbsp; <Tooltip title={(<div><p> It indicates the net learning outcomes calculated by adding learning efficiency and knowledge efficiency with a weightage of 20% and 80% respectively.</p><p>  NA: This data is not available due to the incompletion of the chapter.</p> </div>)}> <icon className="icon-inform text-icon dash-icon-inform" aria-hidden="true"></icon> </Tooltip></Tooltip>,
        key: 'currency', align: 'right',render: (data) =>  data.currency.knowledgeWealth ===  0 ? 'NA': data.currency.knowledgeWealth  + ' %' },
        { 
            // title: 'Currency',
        //   title: 'Score',
        title:<Tooltip>Knowledge Efficiency&nbsp; <Tooltip title={(<div><p> It measures the learning outcomes of the chapter-end quiz, where the student’s conceptual clarity of all topics within that chapter is tested from the total score of 100.</p><p>  NA: This data is not available due to the incompletion of the chapter.</p> </div>)}> <icon className="icon-inform text-icon dash-icon-inform" aria-hidden="true"></icon> </Tooltip></Tooltip>,
        key: 'currency', align: 'right', render: (data) => data.currency.knowledgeCurrency ===  0 ? 'NA': data.currency.knowledgeCurrency +' %' },
        { 
            // title: 'Currency',
        //   title: 'Score',
        title:<Tooltip>Learning Efficiency&nbsp; <Tooltip title="It measures the learning outcomes achieved by a student in a topic. The speed, accuracy, and number of attempts are monitored and tested from the total score of 100."> <icon className="icon-inform text-icon dash-icon-inform" aria-hidden="true"></icon> </Tooltip></Tooltip>,
        key: 'currency', align: 'right', render: (data) => data.currency.learningCurrency ===  0 ? 'NA': data.currency.learningCurrency +' %'},
        { 
        // title: 'Time', 
        title:<Tooltip>Time Spent&nbsp; <Tooltip title="It denotes the total time spent by the student in answering the questions in the chapter."> <icon className="icon-inform text-icon dash-icon-inform " aria-hidden="true"></icon> </Tooltip></Tooltip>,
        dataIndex: 'time', key: 'id', align: 'center' },
        // { 
            // title: 'Currency',
        //   title: 'Score',
    //     title:<Tooltip>Score&nbsp; <Tooltip title="It measures the total score, knowledge efficiency and learning efficiency of the student in the chapter."> <icon className="icon-inform" aria-hidden="true"></icon> </Tooltip></Tooltip>,
    //     key: 'currency', align: 'center', render: (data) => currencyList(data)
    //  },

    ];

    if (showColumns.includes('accuracy')) {
        chapterColumns.splice(4, 0, { 
            // title: 'Accuracy %', 
            title: <Tooltip>Accuracy % &nbsp; <Tooltip title="Accuracy percentage is measured by the ratio of the number of correctly answered questions and the total of attempted questions in the chapter."> <icon className="icon-inform text-icon dash-icon-inform" aria-hidden="true"></icon> </Tooltip></Tooltip>,
            dataIndex: 'accuracy', 
            key: 'id', align: 'right' });
    }

    const topicColumns = [
        { title: 'S.No', dataIndex: 'index', key: 'index' },
        {
            //  title: 'Island Name',
            title:<Tooltip>Topic&nbsp; <Tooltip title="It indicates the name of the topic in the chapter."> <icon className="icon-inform text-icon dash-icon-inform" aria-hidden="true"></icon> </Tooltip></Tooltip>,
            dataIndex: 'topicName',
            align: 'right', 
            key: 'id', render: text => <span className="cursor-pointer">{text}</span> },
        { 
            // title: 'Average Time Per Question',
            title: <Tooltip>Avg Speed &nbsp; <Tooltip title="It measures the average time taken for the student to answer the questions."> <icon className="icon-inform text-icon dash-icon-inform" aria-hidden="true"></icon> </Tooltip></Tooltip>, 
            dataIndex: 'avgTime', 
            key: 'id', 
            render: (data) => <span>{data} sec</span>,
            align: 'center' },
        // { title: 'Grade', dataIndex: 'grade', key: 'id', align: 'center' },
        // { title: 'Accuracy %', dataIndex: 'accuracy', key: 'id', align: 'center' },
        {
            // title: 'Performance', 
            title: 'Learning Efficiency', 
            key: 'performance', 
            align: 'right', 
            dataIndex: 'learningCurrency',
            render: (data) => learningCurrency(data),
            // children: [{
            //     title: 'Learning Currency',
            //     dataIndex: 'learningCurrency',
            //     key: 'id',
            //     width: 200,
            //     render: (data) => learningCurrency(data),
            //     align: 'center'
            // }, 
            // {
            //     title: 'Total Attempt',
            //     dataIndex: 'totalAttempt',
            //     key: 'id',
            //     align: 'center'
            // }, {
            //     title: 'No of Question Attempt',
            //     dataIndex: 'numQuesAttempt',
            //     key: 'id',
            //     align: 'center'
            // }
        // ]
        },
    ];

    // const content = (
    //     <span>It measures the quality of student’s performance in the chapters.</span>        
    //   );
    const columnss = [
        {
          title: 'Grade',
          dataIndex: 'grade',
        },
        {
          title: 'Range',
          dataIndex: 'range',
        },
      ];
      const datas = [
        {
          key: '1',
          grade: 'A+',
          range:'90-100',
        },
        {
          key: '2',
          grade: 'A',
          range: '80-89',
        },
        {
          key: '3',
          grade: 'B+',
          range: '70-79',
        },
        {
            key: '4',
            grade: 'B',
            range: '60-69',
          },
          {
            key: '5',
            grade: 'C+',
            range: '50-59',
          },
          {
            key: '6',
            grade: 'C',
            range: '40-49',
          },
          {
            key: '7',
            grade: 'D+',
            range: '30-39',
          },
          {
            key: '8',
            grade: 'E+',
            range: '20-29',
          },
          {
            key: 'E',
            grade: 'E',
            range: '0-19',
          },
      ];
    const content = (
        // <span>It measures the quality of student’s performance in the chapters.</span>
        <Table columns={columnss} dataSource={datas} pagination={false} size="small" />
      );

    if (showColumns.includes('grade')) {
        topicColumns.splice(3, 0, { 
            // title: 'Grade',
            title: <Tooltip>Grade &nbsp; <Tooltip title={content}> <icon className="icon-inform text-icon dash-icon-inform" aria-hidden="true"></icon> </Tooltip></Tooltip>,
            dataIndex: 'grade', key: 'id', align: 'center' });
    }

    if (showColumns.includes('accuracy')) {
        topicColumns.splice(4, 0, { title: 'Accuracy %', dataIndex: 'accuracy', key: 'id', align: 'center' });
    }

    const chapterProgress = (value) => (
        <Progress
            strokeColor={{
                '0%': '#108ee9',
                '100%': '#87d068',
            }}
            status="active"
            percent={value}
            showInfo={false}
        />
    );

    const learningCurrency = (count) => (
        // <ul className="diamond_img">
        //     <li>
        //         <img src={coin3} alt="silver images" />
        //         <span>{count}</span>
        //     </li>
        // </ul>
        <span>{count}%</span>
    );

    const currencyList = (data) => (
        // <ul className="diamond_img">
        <ul className="diamond_img">
            <li>
                {/* <img src={coin1} alt="dimond images" />
                <span>{data.currency.knowledgeWealth}</span> */}
                 <span>{data.currency.knowledgeWealth}</span>
            </li>
            <li>
                {/* <img src={coin2} alt="gold images" /> */}
                <span>{data.currency.knowledgeCurrency}</span>
            </li>
            <li>
                {/* <img src={coin3} alt="silver images" /> */}
                <span>{data.currency.learningCurrency}</span>
            </li>
            {/* <li className="certificate_icon">
                <img src={certificate} alt="dimond images" />
            </li> */}
        </ul>
    );

    const parseTopic = (data) => {
        return data.map((t, i) => ({
            key: t.topicId,
            index: i + 1,
            topicName: t.topicName,
            // avgTime: Math.round(t.avgTimeperQuestion),
            avgTime: t.avgTimeperQuestion,
            time: moment.utc(t.timeSpend * 1000).format('HH:mm:ss'),
            learningCurrency: Math.round(t.learningCurrency),
            // totalAttempt: Math.round(t.attempt),
            // numQuesAttempt: Math.round(t.totalQuestionsAttempt),
            grade: t.grade || 'NA',
            accuracy: `${t.accuracy ? Math.round(t.accuracy) : 0} %`,
        }));
    }

    const parseChapter = (data) => {
        return data.map((c, i) => ({
            key: c.chapterId,
            index: i + 1,
            chapterName: c.chapterName,
            numIsland: c.noOfIsland,
            chapterComplete: Math.round(c.chapterCompletion),
            accuracy: `${c.accuracy ? Math.round(c.accuracy) : 0} %`,
            time: moment.utc(c.time * 1000).format('HH:mm:ss'),
            currency: {
                knowledgeWealth: Math.round(c.knowledgeWelth),
                knowledgeCurrency: Math.round(c.knowledgeCurrency),
                learningCurrency: Math.round(c.learningCurrency),
            },
            topic: c.topic,
        }));
    }

    const parseSubject = (data) => {
        return data.map((sub, i) => ({
            key: sub.subjectId,
            index: i + 1,
            subjectName: sub.subjectName,
            numIsland: sub.noOfIsland,
            chapterComplete: Math.round(sub.chapterCompletion),
            time: moment.utc(sub.time * 1000).format('HH:mm:ss'),
            currency: {
                knowledgeWealth: Math.round(sub.knowledgeWelth),
                knowledgeCurrency: Math.round(sub.knowledgeCurrency),
                learningCurrency: Math.round(sub.learningCurrency),
            },
            chapter: sub.chapter,
        }));
    }

    const chapterExpandedRowRender = ({ topic = [] }) => {
        return <Table columns={topicColumns} dataSource={parseTopic(topic)} pagination={false} />;
    };

    const subjectExpandedRowRender = ({ chapter = [] }) => {
        return <Table columns={chapterColumns} dataSource={parseChapter(chapter)} pagination={false} expandedRowRender={chapterExpandedRowRender} />;
    };

    // console.log(items);
    
    // items.forEach(function (i, v) {
    //     let calLearningCurrency = [];
    //     console.log(i.topic);
    //     let topic = i.topic;
    //     topic.forEach(function (i1, v1) {
    //         console.log(i1.learningCurrency)
    //         calLearningCurrency.push(Math.round(i1.learningCurrency))
    //     });
    //     console.log(calLearningCurrency)
    //     let finalCurrency = calLearningCurrency.reduce((a, b) => a + b)
    //     i.learningCurrency = finalCurrency
    // });

    let columns = subjectColumns;
    let data = parseSubject(items);
    let expandedRowRender = subjectExpandedRowRender;

    if (type === 'chapter') {
        columns = chapterColumns;
        data = parseChapter(items);
        expandedRowRender = chapterExpandedRowRender;
    } else if (type === 'topic') {
        columns = topicColumns;
        data = parseTopic(items);
    }

    return (
        <Table
            loading={isLoading}
            columns={columns}
            expandedRowRender={expandedRowRender}
            dataSource={data}
            pagination={pagination}
            expandRowByClick={true}
        />
    );
}